// Generated by ReScript, PLEASE EDIT WITH CARE


let logo = "images/lumiguide-logo-02.png";

export {
  logo,
}
/* No side effect */
